import React from "react";

import { Route, Switch } from "react-router-dom";

import HomePage from "../Home/Home";
import LargeCap from "../Pages/LargeCap";
import MidCap from "../Pages/MidCap";
import SmallCap from "../Pages/SmallCap";

export default class Switcher extends React.Component {
  constructor(props) {
    super(props);
    this.links = [

      [
        "proxy",
        "documents/All/Congress_Voting_Table.pdf",
      ],

      [
        "privacy",
        "http://congress-mutual-funds.web.app/privacy",
      ],
      [
        "irs",
        "documents/All/congress-smid-core-opportunity-8937.pdf",
      ],
      [
        "newAcc",
        "documents/All/reg_app_multi.pdf",
      ],
      [
        "iraApp",
        "documents/All/ira_app.pdf",
      ],
      [
        "iraTransfer",
        "documents/All/ira_trans.pdf",
      ],
      // CHANGE THIS
      [
        "iraDisclosure",
        "documents/All/iraDisclosure.pdf",
      ],
      [
        "coverdell",
        "documents/All/coverdell.pdf",
      ],
      [
        "newAccLegal",
        "documents/All/entity_app.pdf"
      ],
      [
        "certification",
        "/documents/All/cert_beneowner.pdf"
      ],

    ];
  }

  render() {
    return (
      <Switch>
        <Route component={HomePage} exact path="/" />
        <Route component={LargeCap} path="/LargeCap/" />
        <Route component={MidCap} path="/MidCap/" />
        <Route component={SmallCap} path="/SmallCap/" />
        {this.links.map((link) => (
          <Route
            key={link[0]}
            path={`/${link[0]}`}
            component={() => {
              window.location.href = link[1];
              return null;
            }}
          />
        ))}
      </Switch>
    );
  }
}
